import React from 'react'
import { useSelector } from 'react-redux'
import { DataGrid } from '@mui/x-data-grid'
import { Box, Grid, Typography } from '../../../../../components/mui/Core/index'
import SummaryTablePagination from '../../../../../components/SummaryTablePagination/summary-table-pagination'
import SubHeader from '../../../../../components/SubHeader/sub-header'
import Constants from '../../../../../constants/en.json'
import { useTheme } from '../../../../../components/mui/Styles/index'

export function SpecialPricingSummaryTable() {
  const theme = useTheme()
  const itemSpecialPricingSummary = useSelector(
    (state) => state.itemSpecialPricing.itemSpecialPricingSummary,
  )
  const isFetchingItemSpecialPricingSummary = useSelector(
    (state) => state.itemSpecialPricing.isFetchingItemSpecialPricingSummary,
  )

  const rows = itemSpecialPricingSummary.map((row) => ({
    id: row.customerGroupNumber,
    customerGroupName: row.customerGroupName,
    price: row.price,
  }))

  const rowsRendered = rows.length > 5 ? rows.slice(0, 5) : rows

  const columns = [
    {
      field: 'customerGroupName',
      headerName: 'Group/Customer',
      sortable: false,
      flex: 1,
      minWidth: 150,
    },
    {
      type: 'number',
      field: 'price',
      headerName: 'Unit Price',
      sortable: false,
      headerAlign: 'right',
      align: 'right',
      valueFormatter: (value) => {
        const price = value
        return `$${price}`
      },
      flex: 0.5,
      minWidth: 100,
    },
  ]

  const specialPricingSummaryTableStyle = {
    ...theme.dataGridMiniTable,
    minHeight: '160px',
    height: isFetchingItemSpecialPricingSummary ? '400px' : 'auto',
  }

  return (
    <Box sx={{ flexGrow: 1, mb: 10 }}>
      <SubHeader title={Constants.specialPricingSummaryTable.SPECIAL_PRICING} />
      {!isFetchingItemSpecialPricingSummary && rowsRendered.length === 0 ? (
        <Grid size={{ xs: 12 }} sx={{ px: 13, mt: 3 }}>
          <Typography variant='message' align='center'>
            {Constants.specialPricingSummaryTable.THERE_ARE_NO_GROUPS}
          </Typography>
        </Grid>
      ) : (
        <DataGrid
          sx={specialPricingSummaryTableStyle}
          rows={rowsRendered}
          columns={columns}
          loading={isFetchingItemSpecialPricingSummary}
          pageSize={5}
          disableRowSelectionOnClick
          slots={{
            pagination: SummaryTablePagination,
          }}
          slotProps={{
            pagination: {
              totalRowsCount: rows.length,
              rowsRenderedCount: rowsRendered.length,
              route: '/itemspecialpricing',
            },
            loadingOverlay: {
              variant: 'skeleton',
              noRowsVariant: 'skeleton',
            },
          }}
        />
      )}
    </Box>
  )
}

export default SpecialPricingSummaryTable
